import styled from "@emotion/styled";
import { DataBlockLayout } from "@rentablo/components";

export const FundamentalsBlockLayout = styled(DataBlockLayout, {
  shouldForwardProp: (prop) => prop !== "stretch",
})<{ stretch?: boolean }>`
  padding: ${({ theme }) => theme.spacing(2)};
  width: 100%;
  height: ${({ stretch = true }) => (stretch ? "100%" : "fit-content")};
`;
